import api from './api';
import {
    NotificationResponse,
    SingleNotificationResponse,
    SendNotificationPayload
} from '../types/notification';

export const notificationService = {
    /**
     * Get all notifications with optional pagination and filters
     */
    getNotifications: async (params?: {
        page?: number;
        limit?: number;
    }): Promise<NotificationResponse> => {
        const response = await api.get('notifications', { params });
        return response.data;
    },

    /**
     * Send a new notification
     */
    sendNotification: async (data: SendNotificationPayload): Promise<SingleNotificationResponse> => {
        const response = await api.post('notifications/send', data);
        return response.data;
    },

    /**
     * Delete a notification by ID
     */
    deleteNotification: async (id: string): Promise<{ success: boolean; message: string }> => {
        const response = await api.delete(`notifications/${id}`);
        return response.data;
    }
};

export default notificationService;
